import { Box, Text } from '@customerio/pluma-components/react';
import { type ReactNode } from 'react';

import * as styles from './dropzone-overlay.css';

interface DropzoneOverlayProps {
  isActive: boolean;
  children?: ReactNode;
  className?: string;
}

export function DropzoneOverlay({ isActive, className, children, ...props }: DropzoneOverlayProps) {
  return (
    <Box className={[styles.overlay, isActive ? styles.overlayActive : styles.overlayInactive, className]} {...props}>
      {children ?? <Text size="l">Drop files to upload</Text>}
    </Box>
  );
}
